let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eqjAL")).then(() => parcelRequire('jFX1p'));